// src/pages/Developer/ChangePassword.tsx

import { ChangePasswordForm } from '@/components/forms/ChangePasswordForm';

/**
 * 修改密码页面
 */
export const ChangePassword = () => {
  return (
    <div className="max-w-lg">
      {/* <h1 className="text-xl font-bold mb-6">修改密码</h1> */}
      <ChangePasswordForm />
    </div>
  );
};